import * as React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface Props {
    label:string;
    name: string; 
    value:Date | undefined; 
    error: boolean;    
    handleDate:any;
    errorText?: string
}

const Datepicker: React.FC<Props> = (props) => {
  const { label, name, value, error, handleDate: handleChange, errorText } = props;

  return (
    <>
      <div
        className="inline"
        style={{
          width: "50%",
          marginBottom: "2px",
          color: error ? "red" : "black",
        }}
      >
        {label}
      </div>
      <div className="inline" style={{ width: "50%", marginBottom: "2px" }}>
      {/** the STYLE is used for styling the DatePicker componenr */}  
      <style>
        {`.date-picker input {
          width: 100%
      }`}
      </style>
        <DatePicker
          wrapperClassName="date-picker" 
          dateFormat="dd/MM/yyyy"          
          selected={value}
          onChange={(date: Date, event: React.SyntheticEvent<any, Event>) =>
            handleChange(date, name)
          }
        /> {errorText}
      </div>
    </>
  );
};

export default Datepicker;


